// removing images because it downloads 100-200MB... that's a no...
// even the instagram component is a bit much. should look into a better way.

// import beCute from "../../images/gif/beCute.gif";
// import catchToy from "../../images/gif/catchToy.gif";
// import couchPlace from "../../images/gif/couchPlace.gif";
// import crawl from "../../images/gif/crawl.gif";
// import crossPaws from "../../images/gif/crossPaws.gif";
// import down from "../../images/gif/down.gif";
// import drinkWater from "../../images/gif/drinkWater.gif";
// import getSlippers from "../../images/gif/getSlippers.gif";
// import holdIt from "../../images/gif/holdIt.gif";
// import leaveIt from "../../images/gif/leaveIt.gif";
// import lookOutTheWindow from "../../images/gif/lookOutTheWindow.gif";
// import pullSocks from "../../images/gif/pullSocks.gif";
// import scoot from "../../images/gif/scoot.gif";
// import sitPretty from "../../images/gif/sitPretty.gif";
// import stand from "../../images/gif/stand.gif";
// import touch from "../../images/gif/touch.gif";
// import tuck from "../../images/gif/tuck.gif";
// import upOff from "../../images/gif/upOff.gif";
// import wave from "../../images/gif/wave.gif";

// const categories = {
// 	1: "Basic",
// 	2: "Circus",
// 	3: "Adorable",
// 	4: "Advanced",
// }

export const tricksData = [
  {
    title: "Couch and Place",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie goes to either couch or place.",
    howTo: "Coming soon...",
    category: "Adorable",
    likes: 0,
  },
  {
    title: "Snow Day sit",
    photo: null,
    video: "",
    instagramURL: "https://www.instagram.com/reel/C4ioXcALwdh",
    description: "Snow Day sit",
    howTo: "just watch",
    category: "Basic",
    likes: 1001,
  },
  {
    title: "Up and Off",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5pi8eKNPxY/",
    description: "Rosie jumps up and off.",
    howTo: "Coming soon...",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Be Cute",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5pg4bsAYuS/",
    description: "Rosie rests her head on your knees.",
    howTo: "Coming soon...",
    category: "Adorable",
    likes: 0,
  },
  {
    title: "Find Mommy/Daddy",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie finds mommy or daddy.",
    howTo: "Coming soon...",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Back",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie moves backwards.",
    howTo: "Coming soon...",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Kisses",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie kisses your cheek/ears.",
    howTo: "Coming soon...",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Selfie",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie takes a selfie with you.",
    howTo: "Coming soon...",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Get Slippers",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/reel/Ca3qAr1vekn/",
    description: "Rosie retrives slippers.",
    howTo: "Coming soon...",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Sit",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie sits on command.",
    howTo:
      "Simply say 'sit' and guide Rosie into a sitting position using a treat or gentle pressure on her back end.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Sit Pretty",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/reel/Casosp2NLdm/",
    description: "Rosie sits up on her hind legs, balancing in a cute pose.",
    howTo:
      "With Rosie in a sitting position, hold a treat above her head, encouraging her to lift her front paws off the ground while balancing.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Shake/Paw",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie offers her paw for a shake.",
    howTo:
      "Extend your hand toward Rosie's paw and say 'shake' or 'paw.' Reward her when she raises her paw to touch your hand.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Stay",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie remains in place until given a release command.",
    howTo:
      "Ask Rosie to 'stay' while holding your hand up in a stop gesture. Start with short durations and gradually increase the time as she learns.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Leave it",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5phxhYOS7Y/",
    description: "Rosie ignores items or treats on the ground when commanded.",
    howTo:
      "Place a treat on the ground and cover it with your hand. When Rosie shows no interest, reward her with a different treat.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Speak",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie barks on command.",
    howTo:
      "Say 'speak' and wait for Rosie to bark. Reward her immediately to reinforce the behavior.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Relax",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie relaxes with her chin resting on the floor.",
    howTo:
      "Encourage Rosie to lie down and then gently press her chin to the floor. Reward her for staying in this position.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Down",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5phS_fOS-j/",
    description: "Rosie lies down on command.",
    howTo:
      "With Rosie in a sitting position, hold a treat near her nose and slowly lower it to the ground, prompting her to lie down.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Crawl",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5phKD3vyE9/",
    description: "Rosie crawls forward with her belly on the ground.",
    howTo:
      "Hold a treat near Rosie's nose and slowly move it forward, encouraging her to crawl while keeping her belly on the ground.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Roll Over",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie rolls onto her back from a lying position.",
    howTo:
      "Ask Rosie to lie down, then hold a treat near her nose and guide her in a circular motion, encouraging her to roll onto her back.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Cross Paws",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/reel/Ca3peG2LDt1/",
    description: "Rosie crosses her front paws while sitting.",
    howTo:
      "With Rosie sitting, gently lift one of her front paws and guide it over the other, crossing them. Reward her for holding this position.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Scoot",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/reel/CbFv0snj0RX/",
    description: "Rosie scoots backward while lying down.",
    howTo:
      "Encourage Rosie to lie down, then gently guide her hindquarters backward while rewarding her for movement.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Stand",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5pit7dM2WV/",
    description: "Rosie stands up on her hind legs briefly.",
    howTo:
      "Hold a treat above Rosie's head, encouraging her to stand on her hind legs to reach it. Reward her for the action.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Drink Water",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5phX1EM94r/",
    description: "Rosie drinks water on command.",
    howTo:
      "Point to the water bowl and say 'drink water' while encouraging Rosie to approach and drink.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Spin",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie spins or turns around.",
    howTo:
      "Hold a treat near Rosie's nose and guide her in a circular motion, encouraging her to spin around. Reward her for completing the spin.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Touch",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5piy46N95v/",
    description: "Rosie touches your hand with her nose.",
    howTo:
      "Hold out your hand, and when Rosie touches it with her nose, reward her immediately. Repeat this action to reinforce the behavior.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Find It",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie sniffs around to find a hidden treat.",
    howTo:
      "Hide a treat in the room and say 'find it' while encouraging Rosie to use her nose to locate the treat. Reward her when she finds it.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Circle",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie walks around you in a circle.",
    howTo:
      "Stand with your legs together and encourage Rosie to walk around you in a circle. Reward her for completing the circle.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Legs",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie comes between your legs.",
    howTo:
      "Spread your legs apart and encourage Rosie to walk between them. Reward her for passing through.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Weave",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie weaves in between your legs.",
    howTo:
      "Take slow, deliberate steps forward, encouraging Rosie to weave between your legs as you move. Reward her for completing the pattern.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Put Toys Away",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie puts her toys in a designated spot.",
    howTo:
      "Point to a toy and say 'put your toy away,' then indicate where you want Rosie to place it. Reward her when she does so.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Chill",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie lays on her side, resembling 'play dead.'",
    howTo:
      "Encourage Rosie to lay on her side and reward her for staying in this position.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Wave",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie waves her paws in a cute gesture.",
    howTo:
      "Encourage Rosie to sit pretty and wave her paws in the air. Reward her for completing the action.",
    category: "Circus",
    likes: 0,
  },
  {
    title: "Catch",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5phGCwOUks/?img_index=1",
    description: "Rosie catches a treat in her mouth.",
    howTo:
      "Throw a treat toward Rosie, saying 'catch,' and reward her if she catches it in her mouth.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Hold It",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5phuBrs6Je/",
    description: "Rosie holds onto a toy or object for several seconds.",
    howTo:
      "Give Rosie a toy or object and say 'hold it,' then reward her for maintaining her grip until you say 'okay.'",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Heel",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie comes to sit next to you on your right side.",
    howTo:
      "Encourage Rosie to come to your right side and sit down. Reward her for following the command.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Tuck",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5pi45KrCrt/",
    description:
      "Rosie crawls under your legs and stays there for a few seconds.",
    howTo:
      "Sit at the edge of a couch or chair and encourage Rosie to crawl under your legs. Reward her for staying in that position.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Say Your Prayers",
    photo: null,
    video: null,
    instagramURL: "",
    description:
      "Rosie puts her paws on your arm and rests her head underneath, resembling prayer.",
    howTo:
      "Kneel down in front of Rosie and hold your arm out, encouraging her to put her paws on it and rest her head. Reward her for completing the action.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Place",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie goes to a designated spot.",
    howTo:
      "Point to where you want Rosie to go and say 'place,' then reward her for going there.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Pull Socks",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5ph8PcrsRE/",
    description: "Rosie pulls socks off your feet.",
    howTo:
      "Put socks on loosely and encourage Rosie to pull them off your feet. Reward her for completing the action.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Look Out the Window",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/p/C5ph1ZvvMN-/",
    description: "Rosie rests her head on the couch and looks out the window.",
    howTo:
      "Encourage Rosie to lay on the couch and look out the window. Reward her for staying in that position.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Hugs",
    photo: null,
    video: null,
    instagramURL: "",
    description: "Rosie puts her paws around your neck for a hug.",
    howTo:
      "Kneel down in front of Rosie and pat your chest, encouraging her to put her paws around your neck. Reward her for completing the action.",
    category: "Basic",
    likes: 0,
  },
  {
    title: "Open Fridge",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/reel/Cby4mPuM8j2/",
    description: "Rosie opens the refrigerator.",
    howTo:
      "",
    category: "Basic",
    likes: 0,
  },
];
